import React, { useEffect, useState } from "react";
import { validate } from "../../util";
import {
  ScrollArea,
  Avatar,
  AvatarImage,
  useToast,
  Switch,
} from "../../components/ui";
import { Header, UserPreview } from "../../components/modules";
import constant, { statuses } from "../../constants";
import { FaPlus } from "react-icons/fa";
import { BiLogIn } from "react-icons/bi";
import { FiUsers } from "react-icons/fi";
import { IoMdTrash } from "react-icons/io";
import { FiCreditCard } from "react-icons/fi";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import Context from "../../Context";
import { RiCoupon2Line } from "react-icons/ri";
import { MdPersonSearch, MdDeleteOutline } from "react-icons/md";
import { Spinner } from "reactstrap";
import { useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { NonBlockLotteryPicker } from "../orders";
import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { DatePicker, Spin } from "antd";
import { resizeImage } from "../../util";
import { TbBrandProducthunt } from "react-icons/tb";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const DonateOrderInfo = () => {
  const { toast } = useToast();
  const { orderId } = useParams();
  const { callApi, navigate, profileState } = Context();
  const [order, setOrder] = useState(false);
  const [user, setUser] = useState(false);
  const [reserveOrder, setReserveOrder] = useState(false);
  const [selectReserve, setSelectReserve] = useState(false);

  const [loading, setLoading] = useState(false);
  const [note, setNote] = useState("");

  useEffect(() => {
    getOrder();
  }, []);

  const getOrder = async () => {
    setLoading(true);
    const { status, data } = await callApi(
      "donates-getTransaction",
      {
        id: orderId,
      },
      {
        notShowLoading: true,
      }
    );

    if (status) {
      setOrder(data);
      console.log("🚀 ~ getOrder ~ data:", data);
      if (data?.user.userId) {
        getUser(data.user.userId);
      }
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: (
          <div className="flex gap-2 items-center">
            <FaTimes /> ไม่พบคำสั่งซื้อ
          </div>
        ),
      });

      //   navigate("/users");
    }
    setLoading(false);
  };

  const getUser = async (userId) => {
    const { status, data } = await callApi(
      "users-getUserInfoAdmin",
      {
        userId,
      },
      {
        notShowLoading: true,
      }
    );

    if (status) {
      setUser(data);
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: (
          <div className="flex gap-2 items-center">
            <FaTimes /> ไม่พบข้อมูลผู้ใช้งาน
          </div>
        ),
      });

      // navigate("/users");
    }
  };
  return (
    <div className="h-fit w-full min-w-[1024px] max-w-[1600px] mx-auto">
      {/* header */}

      <Header
        header="Donates"
        subHeader={`ข้อมูลการบริจาค`}
        icon={<FiCreditCard className="text-blue" />}
      />
      <div className="grid grid-cols-3 w-full gap-3 mt-3">
        {/* order */}
        <div className="col-span-2 ">
          <div className="relative mb-3 bg-white w-full rounded-lg  shadow-md border border-[#E5E7E9] overflow-hidden">
            <div className="flex bg-white items-center gap-3 p-3 border-b border-[#E5E7E9]">
              <p className="font-semibold text-xl">
                ข้อมูลรายการบริจาค{" "}
                <span className="text-green">#{order.shortId}</span>
              </p>
            </div>

            {!order ? (
              <div className="flex justify-center items-center h-64 w-full">
                <Spinner className="w-4 h-4" />
              </div>
            ) : (
              <div className="p-3 grid grid-cols-4 gap-3">
                {loading && (
                  <div className="absolute w-full z-50 h-full bg-[rgb(255,255,255,0.6)] flex items-center justify-center">
                    <Spinner className="w-4 h-4" />
                  </div>
                )}
                <div className="row-span-6">
                  <p className="font-semibold">สถานที่บริจาค</p>
                  <div className="flex">
                    {order.donate?.image ? (
                      <img src={order.donate?.image} alt="donate" />
                    ) : (
                      <p>ไม่พบรูปภาพสถานที่บริจาค</p>
                    )}
                  </div>
                </div>
                <div>
                  <p className="font-semibold">สถานะคำสั่งซื้อ</p>
                  <div className="flex">
                    <select
                      //   disabled={order.status === constant.statuses.CANCEL}
                      className={`${
                        order.status === constant.statuses.APPROVE
                          ? "bg-green text-white"
                          : order.status === constant.statuses.PAID
                          ? "bg-[#4DA1A9] text-white"
                          : //   : order.status === constant.statuses.PENDING
                            //   ? "bg-[#FAB12F] "
                            "bg-[#c15b78] text-white"
                      }  border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:text-gray-500 disabled:border-gray-200 disabled:cursor-not-allowed`}
                      value={order?.status || ""}
                      onChange={async (e) => {
                        if (window.confirm("ต้องการแก้ไขข้อมูลใช่หรือไม่")) {
                          setLoading(true);
                          const { status } = await callApi(
                            "donates-editStatus",
                            {
                              id: order?.id,
                              status: e.target.value,
                            },
                            {
                              notShowLoading: true,
                            }
                          );

                          if (status) {
                            toast({
                              className: "bg-green",
                              title: (
                                <div className="flex gap-2 items-center">
                                  <FaCheckCircle /> อัพเดตข้อมูลสำเร็จ
                                </div>
                              ),
                            });
                            setNote("");
                            getOrder();
                          } else {
                            toast({
                              className: "bg-[#c15b78]",
                              title: (
                                <div className="flex gap-2 items-center">
                                  <FaTimes /> อัพเดตข้อมูลไม่สำเร็จ
                                </div>
                              ),
                            });
                          }
                          setLoading(false);
                        }
                      }}
                    >
                      <option value={constant.statuses.APPROVE}>
                        {constant.statusesTranslate.approved}
                      </option>
                      <option disabled={true} value={constant.statuses.PAID}>
                        {constant.statusesTranslate.paid}
                      </option>
                      {/* <option value={constant.statuses.PENDING}>รอชำระ</option> */}
                      <option value={constant.statuses.CANCEL}>
                        {constant.statusesTranslate.canceled}
                      </option>
                    </select>
                  </div>
                </div>
                <div>
                  <p className="font-semibold">วัน-เวลา สร้างออเดอร์</p>
                  <div className="flex">
                    <input
                      className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm  disabled:border-gray-200 disabled:cursor-not-allowed"
                      type="text"
                      disabled={true}
                      value={
                        new Date(order.createdAt).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                        }) || ""
                      }
                    />
                  </div>
                </div>
                {/* <div>
                <p className="font-semibold">วัน-เวลา หมดอายุ</p>
                <div className="flex">
                  <input
                    className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm  disabled:border-gray-200 disabled:cursor-not-allowed"
                    type="text"
                    disabled={true}
                    value={
                      new Date(order.coupon?.expireAt).toLocaleDateString(
                        "th-TH",
                        {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                        }
                      ) || ""
                    }
                  />
                </div>
              </div> */}
                <div className="">
                  <p className="font-semibold">รหัสคำสั่งซื้อ</p>
                  <div className="flex">
                    <input
                      className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                      type="text"
                      disabled={true}
                      value={order?.shortId || ""}
                    />
                  </div>
                </div>
                {/* <div className="row-span-7">
                <p className="font-semibold">สลิป</p>
                <div className="flex rounded-lg overflow-hidden ">
                  <a href={`${order.slip}`} target="_blank" rel="noreferrer">
                    <img src={order.slip} alt="slip" className="w-96" />
                  </a>
                </div>
              </div> */}

                <div>
                  <p className="font-semibold">สถานที่บริจาค</p>
                  <div className="flex">
                    <input
                      className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                      type="text"
                      disabled={true}
                      value={order?.donate?.name || ""}
                    />
                  </div>
                </div>
                <div>
                  <p className="font-semibold">บริจาคจำนวน </p>
                  <div className="flex">
                    <input
                      className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                      type="text"
                      defaultValue={order?.donateAmount}
                      onBlur={async (e) => {
                        if (window.confirm("ต้องการแก้ไขข้อมูลใช่หรือไม่")) {
                          setLoading(true);
                          const { status } = await callApi(
                            "donates-changePriceByAdmin",
                            {
                              orderId: order?.id,
                              donateAmount: Number(e.target.value),
                            },
                            {
                              notShowLoading: true,
                            }
                          );

                          if (status) {
                            toast({
                              className: "bg-green",
                              title: (
                                <div className="flex gap-2 items-center">
                                  <FaCheckCircle /> อัพเดตข้อมูลสำเร็จ
                                </div>
                              ),
                            });
                            setNote("");
                            getOrder();
                          } else {
                            toast({
                              className: "bg-[#c15b78]",
                              title: (
                                <div className="flex gap-2 items-center">
                                  <FaTimes /> อัพเดตข้อมูลไม่สำเร็จ
                                </div>
                              ),
                            });
                          }
                          setLoading(false);
                        }
                      }}
                    />
                  </div>
                </div>
                <div>
                  <p className="font-semibold">บริจาคโดยการ</p>
                  <div className="flex">
                    <input
                      className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                      type="text"
                      disabled={true}
                      value={order.isDonateWithCash ? "โอนเงิน" : "หักคะแนน"}
                    />
                  </div>
                </div>

                <div>
                  <p className="font-semibold">ชื่อผู้บริจาค</p>
                  <div className="flex">
                    <input
                      className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                      type="text"
                      disabled={true}
                      value={order?.user?.name || ""}
                    />
                  </div>
                </div>
                <div>
                  <p className="font-semibold">เบอร์โทรศัพท์ผู้บริจาค</p>
                  <div className="flex">
                    <input
                      className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                      type="text"
                      disabled={true}
                      value={order?.user?.phone || ""}
                    />
                  </div>
                </div>
                <div className="">
                  <p className="font-semibold">ไอดีสมาชิก</p>
                  <div className="flex">
                    <input
                      className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                      type="text"
                      disabled={true}
                      value={order?.user?.userId || ""}
                    />
                  </div>
                </div>
                <div className="col-span-2">
                  <p className="font-semibold">หมายเหตุ (จากลูกค้า)</p>
                  <div className="flex">
                    <input
                      className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                      type="text"
                      disabled={true}
                      value={order?.customerNote || ""}
                    />
                  </div>
                </div>

                {order?.approvedBy && (
                  <div>
                    <p className="font-semibold">อนุมัติโดย</p>
                    <div className="flex">
                      <input
                        className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                        type="text"
                        disabled={true}
                        value={order?.approvedBy || ""}
                      />
                    </div>
                  </div>
                )}
                {order?.approvedAt && (
                  <div>
                    <p className="font-semibold">วัน-เวลาอนุมัติ</p>
                    <div className="flex">
                      <input
                        className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:border-gray-200 disabled:cursor-not-allowed"
                        type="text"
                        disabled={true}
                        value={
                          new Date(order?.approvedAt).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                            }
                          ) || ""
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <UserPreview user={user} />
        </div>
        <div>
          {/* slip */}
          <div className=" relative h-fit mb-3 bg-white w-full rounded-lg  shadow-md border border-[#E5E7E9] overflow-hidden">
            {loading && (
              <div className="absolute w-full z-50  h-96 bg-[rgb(255,255,255,0.6)] flex items-center justify-center">
                <Spinner className="w-4 h-4" />
              </div>
            )}

            <div className="flex bg-white items-center gap-3 p-3 border-b border-[#E5E7E9]">
              <p className="font-semibold text-xl">สลิป</p>
            </div>

            <div className="flex justify-center items-center rounded-lg min-h-60 overflow-hidden p-3 ">
              {order.slip ? (
                <a href={`${order.slip}`} target="_blank" rel="noreferrer">
                  <img src={order.slip} alt="slip" className="w-full" />
                </a>
              ) : (
                <p className="text-center font-semibold text-gray-300">
                  ไ่ม่พบสลิป
                </p>
              )}
            </div>
          </div>

          {/* note */}
          <div className=" relative h-fit bg-white w-full rounded-lg  shadow-md border border-[#E5E7E9] overflow-hidden">
            {loading && (
              <div className="absolute w-full z-50 h-full bg-[rgb(255,255,255,0.6)] flex items-center justify-center">
                <Spinner className="w-4 h-4" />
              </div>
            )}

            <div className="flex bg-white items-center gap-3 p-3 border-b border-[#E5E7E9]">
              <p className="font-semibold text-xl">โน๊ต</p>
            </div>
            <div className="p-3">
              <div className="flex gap-2 ">
                <input
                  className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                  type="text"
                  id="files-slips"
                  value={note}
                  onChange={(e) => {
                    setNote(e.target.value);
                  }}
                  placeholder="โน๊ต"
                />

                <button
                  disabled={loading.note}
                  className="col-span-2 bg-green rounded-lg w-fit p-2 sticky bottom-4 font-semibold flex justify-center items-center gap-2 text-white hover:opacity-85 disabled:opacity-55"
                  onClick={async () => {
                    if (window.confirm("ต้องการแก้ไขข้อมูลใช่หรือไม่")) {
                      setLoading((prevState) => ({ ...prevState, note: true }));
                      const { status } = await callApi(
                        "donates-adminAddNote",
                        {
                          id: order.id,
                          note: note,
                        },
                        {
                          notShowLoading: true,
                        }
                      );

                      if (status) {
                        toast({
                          className: "bg-green",
                          title: (
                            <div className="flex gap-2 items-center">
                              <FaCheckCircle /> อัพเดตข้อมูลสำเร็จ
                            </div>
                          ),
                        });
                        setNote("");
                        getOrder();
                      } else {
                        toast({
                          className: "bg-[#c15b78]",
                          title: (
                            <div className="flex gap-2 items-center">
                              <FaTimes /> อัพเดตข้อมูลไม่สำเร็จ
                            </div>
                          ),
                        });
                      }
                      setLoading((prevState) => ({
                        ...prevState,
                        note: false,
                      }));
                    }
                  }}
                >
                  เพิ่ม
                </button>
              </div>
              <ScrollArea className="h-[450px] mt-3">
                {order ? (
                  [...(order.notes || []), ...(order.note || [])]?.length >
                  0 ? (
                    [...(order.notes || []), ...(order.note || [])]
                      .sort((a, b) => b?.time - a?.time)
                      .map((note) => (
                        <div
                          className={`bg-blue py-2 px-3 line- relative rounded-lg text-white mb-2`}
                          key={note.time}
                        >
                          <p className="text-lg font-semibold">{note.by}</p>
                          <p className="text-xs font-semibold">
                            {new Date(note.time).toLocaleDateString("th-TH", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                            })}
                          </p>
                          <p className="break-all font-semibold mt-3">
                            {note.note}
                          </p>
                        </div>
                      ))
                  ) : (
                    <div className="h-full w-full flex justify-center items-center text-gray-400 font-semibold">
                      <p>ไม่พบข้อมูล</p>
                    </div>
                  )
                ) : (
                  <></>
                  //   <div className="w-full min-h-64 flex justify-center items-center">
                  //     <Spinner className="w-4 h-4" />
                  //   </div>
                )}
              </ScrollArea>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
